import { storyblokEditable, StoryblokComponent } from "@storyblok/react";

const LargeImageCard = ({ blok }) => {
  return (
    <section
      {...storyblokEditable(blok)}
      className="w-full flex justify-center pb-16"
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-[1300px] w-full">
        {blok.cards?.map((nestedBlok) => (
          <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
        ))}
      </div>
    </section>
  );
};

export default LargeImageCard;
